/* eslint-disable */
import { useMemo } from "react";
import useMRTLocalization from "./useMRTLocalization";

/**
 * Returns a base props object to spread onto every MaterialReactTable in the app.
 *
 * Centralises defaults that should be consistent everywhere:
 *  - filterFn "contains"  → column filters do strict substring matching (not fuzzy)
 *  - globalFilterFn "includesString" → global search does the same
 *  - localization         → always set from the active i18n language
 *
 * Usage:
 *   const appMRTProps = useAppMRT();
 *   <MaterialReactTable {...appMRTProps} columns={...} data={...} />
 *
 * Any prop you pass after the spread will override the default.
 */
const useAppMRT = () => {
  const localization = useMRTLocalization();

  return useMemo(
    () => ({
      localization,
      globalFilterFn: "includesString",
      defaultColumn: { filterFn: "startsWith" },
    }),
    [localization]
  );
};

export default useAppMRT;
